import PropTypes from 'prop-types';
import React, {Component, createElement} from 'react';
import {noop} from '@republic/foundation/lang/function';
import {createComponent, createNamedContext} from '@republic/react-foundation';
import LazyRoute from './LazyRoute';
import LazySwitch from './LazySwitch';

const
    Meta = (
        createNamedContext(
            'Meta',
            {
                noindex: PropTypes.bool,
                nofollow: PropTypes.bool,
                canonical: PropTypes.string
            })),

    withMeta = Meta.with,

    View = (
        createNamedContext(
            'View')),

    withView = View.with,

    createLazyComponent = (
        (name,
        {
            propTypes = {},
            defaultProps = {}
        } = {},
        meta,
        component,
        view) => (
            createComponent(
                name,
                {
                    propTypes,
                    defaultProps
                },
                class Lazy extends Component {
                    static lazy = () => {
                        return (
                            Promise.all([
                                (Promise.resolve(component())
                                .then(component => component)),
                                Promise.resolve(view ? view() : null)
                            ]));
                    };

                    constructor(props) {
                        super(props);
                        this.state = {
                            ready: false,
                            component: null,
                            view: null
                        };
                        this.mounted = false;
                    }

                    componentDidMount() {
                        (Lazy.lazy()
                        .then(([component, view]) => {
                            if (this.mounted) {
                                this.setState({
                                    ready: true,
                                    component,
                                    view
                                });
                            }
                        })
                        .catch(noop));
                        this.mounted = true;
                    }

                    componentWillUnmount() {
                        this.mounted = false;
                    }

                    render() {
                        const {ready, component, view} = this.state;

                        return (
                            ready ?
                                <Meta.Provider value={meta}>
                                    {view ?
                                        <View.Provider value={view}>
                                            {createElement(component, this.props)}
                                        </View.Provider> :
                                        createElement(component, this.props)}
                                </Meta.Provider> :
                                null);
                    }
                })));

export {
    createLazyComponent,
    withMeta,
    withView,
    LazyRoute,
    LazySwitch
};
